import React, { useState, useEffect, useRef, ChangeEvent, FormEvent } from "react";
// import PageTitle from "../../components/shared/PageTitle";
import { useTranslation } from "react-i18next";
import { useLogin } from "../../hooks/useApi";
import { isAuthenticated } from "../../lib/api";
import { AuthLoginErrorResult } from "../../types/api";
// import axios from "axios";

interface FormData {
    uusrEmail: string;
    uusrPassword: string;
}

export default function Index(): React.ReactElement {
    const { t } = useTranslation();
    const isAuth = isAuthenticated();
    if (isAuth) {
        window.location.href = "/profile";
    }
    const loginMutation = useLogin();

    const [isSuccess, setSuccess] = useState<boolean>(false);
    const [isError, setError] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [isUnverifiedModalOpen, setIsUnverifiedModalOpen] = useState(false);
    const [showGenericError, setShowGenericError] = useState(false);

    const [formData, setFormData] = useState<FormData>({
        uusrEmail: "",
        uusrPassword: "",
    });

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();
        setLoading(true);
        setShowGenericError(false);

        const payload = {
            uusrEmail: formData.uusrEmail,
            uusrPassword: formData.uusrPassword,
        };

        loginMutation.mutate(payload, {
            onSuccess: () => {
                setSuccess(true);
                window.location.href = "/profile";
            },
            onError: (error: unknown) => {
                const loginError = error as AuthLoginErrorResult;
                if (loginError.status.error.message === "Email not verified") {
                    setIsUnverifiedModalOpen(true);
                } else {
                    setShowGenericError(true);
                    console.log("Login error:", loginError.status?.error?.message);
                    setLoading(false);
                }
                setError(true);
            },
            onSettled: () => {
                setLoading(false);
            }
        });
    };

    return (
        <div className="text-brandBlue md:px-0 px-4 bg-contactMobile md:bg-contact bg-cover bg-bottom md:bg-right bg-no-repeat">
            {/* <div className="relative">
                <PageTitle title={t("login.title")} />
            </div> */}
            <div className="top-24 md:top-40 relative md:px-16 lg:px-24 xl:px-28 2xl:px-36 px-0 py-5 pb-96">
                <div className="basis-full py-8 md:relative">
                    <span className="font-superWonder text-5xl md:text-8xl text-brandBlue block">{t("login.title")}</span>
                    <span className="font-superWonder max-md:mt-2 text-lg md:text-3xl text-brandYellow bg-brandBlue px-4 py-2 rounded-lg w-full">{t("login.subTitle")}</span>
                </div>
                <div className="bg-white min-h-fit container px-8 py-6 rounded-3xl w-full md:w-1/2 font-poppins text-brandBlue">
                    {isSuccess && (
                        <div className="w-full bg-sky-200 p-4 mb-10 text-sky-800 rounded-lg">
                            <h1>
                                {t("login.successMessage")}
                            </h1>
                        </div>
                    )}

                    {isError && (
                        <div className="w-full bg-red-200 p-4 mb-10 text-red-800 rounded-lg">
                            <h1>{t("login.failedMessage")}</h1>
                        </div>
                    )}
                    <div className="flex items-center justify-start h-full">
                        <form className="w-full space-y-8" onSubmit={handleSubmit}>
                            <div className="space-y-6">
                                <label htmlFor="uusrEmail" className="!font-poppins">{t("login.email")}</label>
                                <input
                                    id="uusrEmail"
                                    name="uusrEmail"
                                    type="text"
                                    value={formData.uusrEmail}
                                    onChange={handleChange}
                                    className="bg-brandLightGrey block border w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-400 text-brandBlaack"
                                    placeholder={t("login.emailPlaceholder")}
                                    required
                                />
                            </div>
                            <div className="space-y-6">
                                <label htmlFor="uusrPassword" className="!font-poppins">{t("login.password")}</label>
                                <input
                                    id="uusrPassword"
                                    name="uusrPassword"
                                    type="password"
                                    autoComplete="new-password"
                                    value={formData.uusrPassword}
                                    onChange={handleChange}
                                    className="bg-brandLightGrey block border w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-400 text-brandBlaack"
                                    placeholder={t("login.passwordPlaceholder")}
                                    required
                                />
                            </div>
                            <div className="flex flex-wrap flex-row md:flex-col gap-4 md:gap-0">
                                {showGenericError && (
                                    <div className="p-3 bg-red-100 text-red-700 rounded-md text-sm text-center mt-2 pb-4">
                                        {t("login.genericErrorMessage")}
                                    </div>
                                )}
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className="w-full md:w-fit px-4 transition-all bg-brandBlue hover:brightness-90 text-white py-2 rounded-lg shadow-2xl uppercase font-bold md:ml-auto"
                                >
                                    {t("login.login")}
                                </button>
                            </div>
                            <div className="w-full flex justify-end">
                                <span
                                    onClick={(e) => {
                                        e.preventDefault();
                                        window.open("https://ultimate10kseries.com/daftar", "_blank");
                                    }}
                                    className="md:w-fit text-brandBlue rounded-lg shadow-2xl font-normal -mt-6 cursor-pointer hover:underline-offset-2 hover:underline transition-all duration-300"
                                >
                                    {t("login.ctaRegisterNow")}
                                </span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Unverified Account Modal */}
            {isUnverifiedModalOpen && <UnverifiedModal onClose={() => setIsUnverifiedModalOpen(false)} />}
        </div>
    );
}

// Unverified Modal Component
interface UnverifiedModalProps {
    onClose: () => void;
}

const UnverifiedModal: React.FC<UnverifiedModalProps> = ({ onClose }) => {
    const { t } = useTranslation();
    const modalRef = useRef<HTMLDivElement>(null);

    // Handle click outside to close
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.body.style.overflow = "hidden";

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.body.style.overflow = "unset";
        };
    }, [onClose]);

    // Handle escape key to close
    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", handleEscape);

        return () => {
            document.removeEventListener("keydown", handleEscape);
        };
    }, [onClose]);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
                aria-hidden="true"
            />

            {/* Modal Container */}
            <div
                ref={modalRef}
                className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden transform transition-all"
                role="dialog"
                aria-modal="true"
                aria-labelledby="unverified-modal-title"
            >
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#164481] to-[#1a5299]">
                    <h2
                        id="unverified-modal-title"
                        className="text-xl font-bold text-white font-poppins flex items-center gap-3"
                    >
                        <svg
                            className="w-6 h-6 text-[#eccd38]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            />
                        </svg>
                        {t("login.unverifiedModal.title", "Account Not Verified")}
                    </h2>
                    <button
                        onClick={onClose}
                        className="p-2 rounded-full text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                        aria-label={t("login.unverifiedModal.closeButton", "Close")}
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                {/* Content */}
                <div className="p-6">
                    <div className="text-center">
                        <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                />
                            </svg>
                        </div>
                        <p className="text-gray-600 mb-6">
                            {t("login.unverifiedModal.message", "Your email address has not been verified yet. Please check your inbox for the verification email or contact support.")}
                        </p>
                        <button
                            onClick={onClose}
                            className="w-full px-6 py-3 bg-[#164481] hover:bg-[#1a5299] text-white font-semibold rounded-lg shadow-lg transition-all"
                        >
                            {t("login.unverifiedModal.closeButton", "Close")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
